/* eslint-disable max-len */
import React, { useEffect, useState, Suspense, useContext, useCallback, useRef } from 'react';
import CardHeader from '../../../../../components/CardHeader';
import TopBarWithShadow from '../../../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../../../components/CustomOverlay';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import { dataService } from '../../../../../services/data.services';
import GlobalContext from '../../../../../components/Context/GloablContext';
import ItemsTable from './components/ItemsTable';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import Loader from '../../../../../components/Loader';

const PromotionDetails = () => {
    let {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [loadingTable, setLoadingTable] = useState(false);
    const [promotionDetails, setPromotionDetails] = useState();
    const [students, setStudents]= useState()
    const [searchParams,setSearchParams] = useSearchParams({student_page_number:1});
    const navigate = useNavigate();
    const [exportBtnLoading, setExportBtnLoading] = useState(false)
    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext);
    console.log(searchParams.toString())

    const isFirstLoad = useRef(true);

    const getViewPromoteHistoryDetails = useCallback(async () => {
        try {
            const branch_id = await GetBranchId();
            const promoteHistoryID = encodeURIComponent(id);

            if (isFirstLoad.current) {
                setLoading(true);
                isFirstLoad.current = false;
            } else {
                setLoading(false);
            }

            setLoadingTable(true);

            let pageNumber = searchParams.get("student_page_number") || "1";
            let filter = searchParams.get("filter");
            let search = searchParams.get("search");

            let endpoint = `promote-students/details?_id=${promoteHistoryID}&branch_id=${branch_id}&page_number=${pageNumber}&limit=10`;

            if (filter !== null && filter.trim() !== "") {
                endpoint += `&filter=${filter}`;
            }

            if (search !== null && search.trim() !== "") {
                endpoint += `&search=${encodeURIComponent(search)}`;
            }

            const response = await dataService.GetAPI(endpoint);
            setPromotionDetails(response?.data?.data);
        } catch (error) {
            navigate("/404");
            console.error(error);
        } finally {
            setLoading(false);
            setLoadingTable(false);
        }
    }, [searchParams]);

    
    const handleOnClickPageNumber = (pageNum) => {
        console.log("skjdnksjd", searchParams);
        const params = Object.fromEntries(searchParams);
        setSearchParams({ ...params, student_page_number: pageNum.selected + 1 });
    };

    const handleExport = async () => {
        try {
            setExportBtnLoading(true);
            const branch_id = await GetBranchId();
            let promoteHistoryID = encodeURIComponent(id);
            let endpoint = `promote-students/details?_id=${promoteHistoryID}&branch_id=${branch_id}&page_number=1&limit=5&export=true`;
            const response = await dataService.GetAPI(endpoint)
            setToastmessage(response?.data?.data?.message)
            window.open(response?.data?.data?.pre_signed_url)
        }catch(error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally {
            setExportBtnLoading(false)
        }
        
       
    }
  
    useEffect(() => {
        getViewPromoteHistoryDetails();
    }, [searchParams]);

    

    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="Promotion Details"
                isback={true}
                backLocation={`/student-master/promote-history?${searchParams.toString()}`}
                rightContent={
                    <button id='export' className={`view-actn-btn`} onClick={handleExport}>
                        {exportBtnLoading ? <Loader colorCode='#106EB4'/> : 'Export'}
                    </button>
                }
            />
            <Suspense fallback={<CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />}>
                {loading ? (
                    <CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />
                ) : promotionDetails ? (
                    <div className="mainDataCntnrPageDiv scrollBlue_thick">
                        <div className='w-[73%] mx-auto mb-4'>
                            <div className="border rounded border-[#c2dcef]  p-3 mb-6">
                                <div className="flex justify-start gap-20 items-center">
                                    <div>
                                        <span className="text-black " id='po_amount_label'>Current Class</span>
                                        <span className="ml-4 font-semibold" >{promotionDetails?.data?.current_class?.academic_year_name} {promotionDetails?.data?.current_class?.class_name}, {promotionDetails?.data?.current_class?.section_name} </span>
                                    </div>
                                    <div>
                                        <span className="text-black" id='po_amount_label'>Promoted to</span>
                                        <span className="ml-4 font-semibold" >{promotionDetails?.data?.promoted_class?.academic_year_name} {promotionDetails?.data?.promoted_class?.class_name}, {promotionDetails?.data?.promoted_class?.section_name}</span>
                                    </div>
                                </div>
                            </div>
                            {/* Stats */}
                            <div className="grid grid-cols-3 mb-6">
                                <div className="border-t rounded-tl rounded-bl border-l border-b border-[#c2dcef]  p-3 text-center  cursor-pointer" onClick={() => setSearchParams({ ...Object.fromEntries(searchParams), filter: '' })}>
                                    <div className="text-black font-semibold" id='po_amount_label'>Total # of Students</div>
                                    <div className="text-black font-normal text-lg underline" >{promotionDetails?.data?.total_students_count }</div>
                                </div>
                                <div className="border  border-[#c2dcef]  p-3 text-center cursor-pointer" onClick={() => setSearchParams({ ...Object.fromEntries(searchParams), filter: true })} >
                                    <div className="text-black font-semibold" id='po_amount_label'># of Students Promoted</div>
                                    <div className="text-black font-normal text-lg underline" >{promotionDetails?.data?.promoted_students_count}</div>
                                </div>
                                <div className="border-t rounded-tr rounded-br border-r border-b border-[#c2dcef]  p-3 text-center cursor-pointer" onClick={() => setSearchParams({ ...Object.fromEntries(searchParams), filter: false })}>
                                    <div className="text-black font-semibold" id='po_amount_label'># of Students not Promoted</div>
                                    <div className="text-black font-normal text-lg underline" >{promotionDetails?.data?.not_promoted_students_count}</div>
                                </div>
                            </div>
                        </div>            
                        <div className="mt-[30px] w-[73%] mx-auto">
                            <ItemsTable total_count={promotionDetails?.data?.students_list_count} items={promotionDetails?.data?.students} handleSearch={getViewPromoteHistoryDetails} loading={loadingTable} searchParams={searchParams} setSearchParams={setSearchParams} handleOnClickPageNumber={ handleOnClickPageNumber} />
                        </div>
                    </div>
                ) : (
                    <div className="flex justify-center items-center h-64">
                        <p className="text-gray-500">No promotion details found</p>
                    </div>
                )}
            </Suspense>
        </CardHeader>
    );
};



export default PromotionDetails